import { RefObject, useEffect } from 'react';

const RAIL_HEIGHT_VAR = '--popp-filter-rail-height';

// The chips wrap, so the rail's height is only known once rendered.
export const useFilterRailHeight = (
  ref: RefObject<HTMLElement>,
  isAnchored: boolean
) => {
  useEffect(() => {
    const rail = ref.current;
    if (!rail || !isAnchored) return;

    const target =
      rail.closest<HTMLElement>('[data-scroll-container]') ??
      rail.parentElement;
    if (!target) return;

    const publish = () =>
      target.style.setProperty(RAIL_HEIGHT_VAR, `${rail.offsetHeight}px`);

    publish();

    const observer = new ResizeObserver(publish);
    observer.observe(rail);

    return () => {
      observer.disconnect();
      target.style.removeProperty(RAIL_HEIGHT_VAR);
    };
  }, [ref, isAnchored]);
};
